import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  const saferGamblingLinks = [
    {
      name: 'GambleAware',
      url: 'https://www.gambleaware.org',
      logo: '/images/footer/gambleaware.webp'
    },
    {
      name: 'GamCare',
      url: 'https://www.gamcare.org.uk',
      logo: '/images/footer/gamcare.webp'
    },
    {
      name: 'Gambling Therapy',
      url: 'https://gamblingtherapy.org',
      logo: '/images/footer/gambling-therapy-logo.webp'
    },
    {
      name: 'Gambling Commission',
      url: 'https://www.gamblingcommission.gov.uk',
      logo: '/images/footer/gamblingcommission.webp'
    }
  ];

  return (
    <footer className="bg-black border-t border-primary-green/30 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-primary-green font-bold mb-4">Your Casinos</h3>
            <p className="text-gray-400 text-sm">
              Independent reviews of UK casino offers. Compare bonuses, payout speeds, and find the best deals.
            </p>
          </div>
          <div>
            <h3 className="text-primary-green font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-gray-400 hover:text-primary-green">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/compare" className="text-gray-400 hover:text-primary-green">
                  Compare Offers
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-primary-green">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-primary-green">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-primary-green font-bold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/policies/privacy" className="text-gray-400 hover:text-primary-green">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/policies/cookies" className="text-gray-400 hover:text-primary-green">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/policies/terms" className="text-gray-400 hover:text-primary-green">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-primary-green font-bold mb-4">Responsible Gambling</h3>
            <div className="grid grid-cols-2 gap-4">
              {saferGamblingLinks.map(link => (
                <a
                  key={link.name}
                  href={link.url}
                  target="_blank"
                  rel="noreferrer noopener"
                  className="block hover:opacity-80 transition-opacity"
                >
                  <img
                    src={link.logo}
                    alt={link.name}
                    className="h-12 w-auto object-contain"
                    loading="lazy"
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="border-t border-primary-green/30 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} Your Casinos. All rights reserved. 18+ Only. BeGambleAware.</p>
        </div>
      </div>
    </footer>
  );
};

